/**
 * Created by chenjia on 2016/10/9.
 */
'use strict';

const isLoginModel = require('../../model/isLoginModel/isLoginModel');

let login = {
    isLogin: function(callback) {
        isLoginModel.isLogin("", (data) => {
            if($.isFunction(callback)) {
                callback(data);
            }
        });
    }
};

module.exports = login;


// WEBPACK FOOTER //
// ./src/js/unit/isLogin/isLogin.js